module.exports = __webpack_public_path__ + "img/k7.dd88c087.jpg";